import { useEffect, useState } from "react";
import { getCombos, getPoblacion, setEstado, setIndicadorPoblacion } from '../componentes/api.js';
import { Alert, AlertTitle, TextField } from '@mui/material';
import { Button, Table} from 'react-bootstrap';
import Pregunta from '../comun/VentanaModal.jsx';


const Poblacion=(props)=>{
  /**Para la lista del combo */
  const [poblacion, setPoblacion] = useState([]);
  /** Esta es la lista de población del proyecto */
  const [datos, setDatos] = useState([]);
  /** Registro que contiene los datos a grabar, modificar o eliminar */
  const [reg, setReg] = useState({
    Id:'',
    IdPoblacion:'',
    Poblacion:'',
    Cantidad:0,
    Anular: false
  });

   /** Para el manejo de la ventana de mensajes modal**/
   const [show, setShow] = useState(false);
   const [msg, setMsg] = useState([]);
   const [btn, setBtn] = useState('');
   const handleClose = () => setShow(false);
  
  useEffect(()=>{
    const cargarCombos = async(datos)=>{
      try {
        const response = await getCombos(datos)
        setPoblacion(response.data)
              
      } catch (error) {
        props.mostrarMsg(["ERROR", "Ocurrio un error al cargar el listado de Población", error])
      }
    }

    cargarCombos({"Tabla":"poblacion","Campo":""},"Poblacion");

    if(props.boton==='buscar' && props.idProyecto!=='' && (props.Objetivo!=='' || props.Resultado!=='')){
      cargarPoblacion();
    }
    if(props.boton==='grabar' && props.idProyecto!=='' && (props.Objetivo!=='' || props.Resultado!=='')){
      grabar();
    }
    if(props.boton==='nuevo'){
      setDatos([]);
    }
  },[props])
  

  const agregar=(event)=>{
    event.preventDefault();
    if(reg.IdPoblacion===''){
      props.mostrarMsg(["Por favor seleccione un Tipo de Población"])
    }else if(reg.Cantidad===0){
      props.mostrarMsg(["Por favor digite la Cantidad numérica de Población que requiere!"])
    }else{
      let encontrado = 0
      datos.map(function(r,i){
        if(r.IdPoblacion == reg.IdPoblacion){ encontrado=1 } 
      })
      if(encontrado===0){
         setDatos([...datos, reg])
      }else{
        props.mostrarMsg(['La Población: "' + reg.Poblacion + '" ya se encuencuentra agregado al Indicador!'])
      }
    }
    
  }

  const anular=async(event, reg)=>{
    event.preventDefault()
    setReg(reg)
    setMsg(["Esta seguro de Anular?","Por favor revise si realmente desea Anular la Población!"])
    setShow(true)
    setBtn('Si')
  }



  const asignarDato =(event)=>{
    event.preventDefault();
    let index = event.target.selectedIndex;
    if(event.target.name ==='Poblacion'){
      setReg({...reg, ['IdPoblacion']:event.target.value, [event.target.name]: event.target.options[index].text})
    }else{
      setReg({...reg, [event.target.name]: event.target.value, ['Estado']:'Nuevo'})
    }
  }

  const cargarPoblacion = async()=>{
   
    try {
      const response = await getPoblacion({'Proyecto' : props.idProyecto, 'Objetivo':props.Objetivo ,'Resultado': props.Resultado})
      if(response.data.length > 0) {
        setDatos(response.data)
        props.setBoton('')
      }else{
        setDatos([]);
      }
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al cargar el listado de Población", error])
    }
  }

  const grabar=async()=>{
    datos.map(function(fila){
      if(fila.Id===''){
        grabarRegistro(fila);
      }
    })
    props.setBoton('');
    cargarPoblacion();
  }

  const grabarRegistro=async(fila)=>{
    try {
      const response = await setIndicadorPoblacion(
        {
          reg:fila, 
          'Proyecto' : props.idProyecto, 
          'Objetivo':props.Objetivo,
          'Resultado': props.Resultado,
          'Usuario': props.UsuarioReg,
        })
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al grabar la Población", error])
    }
  }
  


  const pregunta=async()=>{
    if(reg.Id===''){
      setDatos(datos.filter(a => a.IdPoblacion!==reg.IdPoblacion))

    }else{
      try {
        await setEstado({'Tabla':'indicador_poblacion', 'Estado':0, 'Id':reg.Id})
        cargarPoblacion()
        props.mostrarMsg(["Se quitó con éxito la Población"])
        
  
      } catch (error) {
        props.mostrarMsg(["ERROR", "Ocurrio un error al Anular la Población", error])
      }
    } 
  }

  return(
    <div className="container card mt-3">
      <div className="row mb-3">
        <Alert severity="info">
          <AlertTitle>Seleccione la Población Objetivo y digite la Cantidad por cada tipo de Población</AlertTitle>
        </Alert>
      </div>

      <div className="row">
        <div className="col-sm-8 ">
          <div className="row form-floating mb-3 m-1">
            <select
              type="text" 
              className="form-control" 
              name='Poblacion' 
              value={reg.IdPoblacion} 
              onChange={(event) =>{asignarDato(event)}}
            >
              <option key='0' value='0'>Seleccione una Población...</option>
              {poblacion.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}> {reg.Nbre} </option>
                );
              })}
            </select>
            <label htmlFor="Poblacion">Tipo de Población</label>
          </div>
        </div> 

        <div className="col-sm-2">
          <TextField
            name="Cantidad"
            label="Cantidad"
            className="form-control"
            type="number"
            value={reg.Cantidad}
            onChange={asignarDato}
          />
        </div>

        <div className="col-sm-2">
          <Button className="from-control" onClick={(event) => agregar(event)}>Agregar</Button>
        </div>
      </div>

      <div className="row mt-2">
        <Table className="table table-hover table-bordered" responsive>
          <thead className="table-primary">
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Población</th>
              <th scope="col">Cantidad</th>
              <th scope="col">Anular</th>
            </tr>
          </thead>
          <tbody>
           {datos!==undefined && datos.length > 0 && datos.map((registro, i)=>{
              return(
              <tr key={i} >
                <th> {registro.Id} </th>
                <th> {registro.Poblacion} </th>
                <th> {registro.Cantidad} </th>
                <th> 
                  <Button className="btn btn-danger" onClick={(event) => anular(event, registro)}>Anular</Button>
                </th>
              </tr>
              )
            })}
             
          </tbody>
        </Table>
      </div>
      <Pregunta show={show} handleClose={handleClose} msg={msg} boton={btn} pregunta={pregunta}/>
    </div>
  )
}

export default Poblacion